export default {
  endpoint: '/uploads'
}
